import { OpenAPIV3 } from 'openapi-types';
import { Api } from '@api-platform/api-doc-parser/lib/Api';
import handleJson, { removeTrailingSlash } from './handleJson';
import fetchQueuedRetry from '~/Admin/data/utils/fetchQueuedRetry';

export interface ParsedOpenApi3Documentation {
  api: Api;
  response: OpenAPIV3.Document;
  status: string;
}

export default function parseOpenApi3Documentation(
  entrypointUrl: string,
  auth: any
): Promise<ParsedOpenApi3Documentation> {
  entrypointUrl = removeTrailingSlash(entrypointUrl);
  const options = {
    headers: {
      Authorization: `Bearer ${auth.authToken}`,
    },
  };
  return fetchQueuedRetry(entrypointUrl, options)
    .then(({ json }) => {
      let baseUrl = (json.servers[0] && json.servers[0].url) || entrypointUrl;
      if (!baseUrl.includes('http')) baseUrl = `https://api.colonynetworks.com${baseUrl}`;
      const title = json.info.title;
      const resources = handleJson(json, entrypointUrl, auth.roles);
      return Promise.resolve({
        api: new Api(baseUrl, { title, resources }),
        response: json,
        status: json.status,
      });
    })
    .catch(err => {
      console.error('openapi3 fetch', err);
      return Promise.reject({ api: new Api(entrypointUrl, { resources: [] }), response: {}, status: 0 });
    });
}
